export default __webpack_public_path__ + "assets/tiktok-video.mp4";